import Card from "components/Card/Card";
import { ControlledInput } from "components/Card/ControlledInput";
import { MaskedInput, TextInput } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes, TinType } from "types/DataTypes";

type RRETinMailingAddressSectionProps = {
  control: Control<TinType>;
  getValues: UseFormGetValues<TinType>;
  setValue: UseFormSetValue<TinType>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const RRETinMailingAddressSection = ({
  control,
  handleFieldChange,
  constants,
}: RRETinMailingAddressSectionProps) => {
  return (
    <Card heading="TIN Office Code Mailing Address">
      <ControlledInput
        control={control}
        name="tin_office_code_mailing_address_line1"
        label="Address Line 1"
        placeholder="Enter Address Line 1"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("tin_office_code_mailing_address_line1", value)
        }
        componentType={TextInput}
        maxLength={50}
      />

      <ControlledInput
        control={control}
        name="tin_office_code_mailing_address_line2"
        label="Address Line 2"
        placeholder="Enter Address Line 2"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("tin_office_code_mailing_address_line2", value)
        }
        componentType={TextInput}
        maxLength={50}
      />

      <ControlledInput
        control={control}
        name="tin_office_code_city"
        label="City"
        placeholder="Enter City"
        errors={{}}
        onSave={(value) => handleFieldChange("tin_office_code_city", value)}
        componentType={TextInput}
        maxLength={30}
      />

      <ControlledSelect
        control={control}
        name="tin_office_code_state"
        label="State"
        placeholder="Select State"
        errors={{}}
        options={constants?.STATES || []}
        onSave={(option) =>
          handleFieldChange("tin_office_code_state", option?.value)
        }
      />

      <ControlledInput
        control={control}
        name="tin_office_code_zipcode"
        label="Zip Code"
        placeholder="Enter Zip Code"
        errors={{}}
        onSave={(value) => handleFieldChange("tin_office_code_zipcode", value)}
        componentType={MaskedInput}
        mask="zipcode"
      />

      <ControlledInput
        control={control}
        name="tin_office_code_zip_plus_4"
        label="Zip+4"
        placeholder="Enter Zip+4"
        errors={{}}
        onSave={(value) =>
          handleFieldChange("tin_office_code_zip_plus_4", value)
        }
        componentType={MaskedInput}
        mask="zipcode-four"
      />
    </Card>
  );
};

export default RRETinMailingAddressSection;
